module.exports = __webpack_public_path__ + "img/Shape-line.b98243e4.svg";